import { is } from 'ramda';
import isNil from 'ramda/src/isNil';

/**
 * Checks if a value is null, undefined, or not number
 * @param value
 */
export const isNilOrNaN = (value: any): boolean =>
  isNil(value) || isNaN(value) || !is(Number, value);
